import React from 'react'

const Useragent = () => {
    if (/android/i.test(navigator.userAgent)) {
window.location.href = 'https://play.google.com/store/apps/details?id=io.floxypay.fxy.twa';
} else if (/iphone|ipad|ipod/i.test(navigator.userAgent)) {
window.location.href = 'https://apps.apple.com/ae/app/digix/id6748937592';
} else {
window.location.href = 'https://floxypay.io';
}
  return (
    <>
    </>
  )
}

export default Useragent